export class ListData {
    data!: {
        total: number;
        count_not_ended: number;
        count_ended: number;
        list: {
            id: string
            name: string
            amount: number
            buy: string
            get: string
            currency: string
            companies_count: number
            for_all_company: string
            start_at: string
            end_at: string
            created_at: string
            vendor: Vendor
            offer_type: OfferType
            offers_used_and_applied_count: number
            offers_used_and_not_applied_count: number
        }[];
    }
    permissions!: any
}

export class Vendor {
    id!: string
    name_ar!: string
    name_en!: string
    name!: string
    logo!: string
    for_all_branches!: number
    branches_count!: number
}
export class OfferType {
    id!: string
    name!: string
    code!: string
}

export class ListFilter {
    page?: number;
    perPage?: any;
    sort?: any;
    sortBy?: any; // created_at, claimed, redeemed
    search?: string; // Offer name, vendor name
    city_id?: any
    vendor_id?: any
    branch_id?: any
    company_id?: any
    offer_type_id?: any
    // type?: any // not_customized, customized
    not_ended_yet?: boolean
    status?: offerStatus
    ended?: boolean
    department_id?: string;
}

export enum sortList {
    ASC = "ASC",
    DESC = 'DESC',
    created_at = 'created_at',
    claimed = 'claimed',
    redeemed = 'redeemed'
}

export enum Type {
    not_customized = 'not_customized',
    customized = 'customized'
}

export enum offerStatus {
    not_ended_yet = 'not_ended_yet',
    ended = 'ended'
}



